import { __decorate } from "tslib";
import { Mixins, Component } from 'vue-property-decorator';
import { Hooper, Slide, Pagination as HooperPagination } from 'hooper';
import { CG_BASE_URL } from '@/helpers/constants/app';
import HeroBanner from '../components/LandingHeroBanner.vue';
import TheFooter from '../components/Footer.vue';
import GetStarted from '../components/GetStarted.vue';
import MerchantsList from '../components/MerchantsList.vue';
import BundleTypes from '../components/BundleTypes.vue';
import Awards from '../components/Awards.vue';
import ViewportSizeMixin from '../helpers/mixins/ViewportSizeMixin';
import UserAgentMixin from '../helpers/mixins/UserAgentMixin';
import FacebookPixelMixin from '../helpers/vue_mixins/v2/FacebookPixelMixin';
import SegmentAnalyticsMixin from '../helpers/vue_mixins/v2/SegmentAnalyticsMixin';
import 'hooper/dist/hooper.css';
import { S3_ASSETS_BUCKET_URL } from '../helpers/constants/LandingPage';
let Home = class Home extends Mixins(FacebookPixelMixin, SegmentAnalyticsMixin, ViewportSizeMixin, UserAgentMixin) {
    constructor() {
        super(...arguments);
        this.currentSlide = 0;
    }
    get landingHeroBannerHeight() {
        return this.mdAndUp ? '700px' : '338px';
    }
    get pressReleasesLinks() {
        return [
            {
                src: `${S3_ASSETS_BUCKET_URL}/anc.svg`,
                link: 'https://www.youtube.com/embed/TO1ryof_0N8',
            },
            {
                src: `${S3_ASSETS_BUCKET_URL}/philstar.png`,
                link: 'https://star34.philstarlife.com/article/623276-there-s-always-a-genie-in-every-crisis',
            },
            {
                src: `${S3_ASSETS_BUCKET_URL}/the-manila-times.png`,
                link: `https://www.manilatimes.net/2021/03/21/business/sunday-business/a-
               life-in-tech/853861/?fbclid=IwAR00Fx_FZYWt5iiPiH2YeEKoeCJvZx20LYY
               xWcKpDkeCqynZKfR1cP6x3T0`,
            },
            {
                src: `${S3_ASSETS_BUCKET_URL}/abs-cbn.png`,
                link: 'https://news.abs-cbn.com/life/06/10/21/shopping-shorts-pride-themed-items-mattress-sale-and-more',
            },
            {
                src: `${S3_ASSETS_BUCKET_URL}/lionheart.png`,
                link: 'https://www.lionheartv.net/2021/05/' +
                    'chatgenie-partners-with-gcash-glife-program-to-empower-more-online-merchants/',
            },
            {
                src: `${S3_ASSETS_BUCKET_URL}/manila-bulletin.png`,
                link: 'https://mb.com.ph/2021/05/26/' +
                    'chatgenie-ph-partners-with-gcash-glife-program-to-empower-more-online-merchants/',
            },
            {
                src: `${S3_ASSETS_BUCKET_URL}/adobo-magazine.png`,
                link: 'https://adobomagazine.com/philippine-news/brand-business-chatgenie' +
                    '-ph-partners-with-gcash-glife-program-to-empower-more-online-merchants/',
            },
            {
                src: `${S3_ASSETS_BUCKET_URL}/forbes-100.png`,
                link: 'https://www.forbes.com/sites/forbesasiateam/2021/08/09/forbes-asia-100-to-watch/?sh=1fc47fdd3752&fbclid=' +
                    'IwAR0ya2G1IScnFBZzNxWe43yaeD4zjsZYQPacYgQFDzmMS_N5MgklApcxEPw',
            },
            {
                src: `${S3_ASSETS_BUCKET_URL}/abs-cbn.png`,
                link: 'https://news.abs-cbn.com/business/08/10/21/philippine-firms-among-forbes-asia-100-to-watch-list?fbclid=' +
                    'IwAR2xUlZDQfZbScfXODSveuZ3gfGJL_bCGmODKbmdBGL7oR-OPpjbWzmTO4E',
            },
        ];
    }
    get benefits() {
        return [
            {
                title: 'Sell everywhere',
                description: `Sell where your customers are. Be it on social media, messaging,
                      mobile wallet, or live streaming apps with just one platform.`,
                src: `${S3_ASSETS_BUCKET_URL}/benefit-customer-reach.png`,
            },
            {
                title: 'Offer quick delivery',
                description: `Since more and more people prefer ordering online while staying at home,
                      delivering orders most of the time is the new norm. We’ve partnered with quality
                      delivery services to get your goods right on your customers’ doorsteps.`,
                src: `${S3_ASSETS_BUCKET_URL}/benefit-quick-delivery.png`,
            },
            {
                title: 'More payment options mean better conversion rates',
                description: `Get paid with payment options that are preferred by your customers. Accept GCash, bank transfer, 
                      debit/credit card payments, mobile banking, and even cash on delivery if applicable.`,
                src: `${S3_ASSETS_BUCKET_URL}/benefit-fast-payment.png`,
            },
            {
                title: 'Let customers track your orders real time',
                description: `Be at ease when customers are anticipating your orders. They can simply track
                      their orders in real time.`,
                src: `${S3_ASSETS_BUCKET_URL}/benefit-track-orders.png`,
            },
        ];
    }
    get howItWorksList() {
        return [
            {
                title: 'Set up your store and sell products or services',
                description: `Setup your store in minutes. No upfront and monthly subscription fees under
                      Free-tier Subscription. No credit card information required. You'll have
                      more time to find the best selling products and services when the online
                      ordering process is automated.`,
                src: `${S3_ASSETS_BUCKET_URL}/store-setup.png`,
            },
            {
                title: 'Activate automated delivery booking feature',
                description: `No need to book deliveries separately. Once you confirmed orders on your dashboard,
                      Grab will assign the delivery to the nearest rider near the assigned pick-up location`,
                src: `${S3_ASSETS_BUCKET_URL}/track-orders-payments.png`,
            },
            {
                title: 'Manage orders from different sales channels on a single dashboard',
                description: `Track all orders coming from Facebook Messenger, Instagram, Viber, GCash in one single location.`,
                src: `${S3_ASSETS_BUCKET_URL}/get-insights.png`,
            },
            {
                title: `For Shopify Stores: No need to re-upload your store content,
                just connect your Shopify to the Mini App`,
                description: `Add another sales channel on Messenger that has 15% overall
                      conversation and track and manage orders on the same Shopify dashboard.`,
                src: `${S3_ASSETS_BUCKET_URL}/how-it-works-shopify.png`,
            },
        ];
    }
    get transactionCountList() {
        return [
            {
                label: 'businesses transacting on FB Messenger using ChatGenie',
                value: '1,500+',
            },
            {
                label: 'Worth of transactions done via ChatGenie',
                value: '₱100M',
            },
            {
                label: 'third-party partners we have worked with',
                value: '20+',
            },
        ];
    }
    get partners() {
        return [
            `${S3_ASSETS_BUCKET_URL}/partner-facebook.png`,
            `${S3_ASSETS_BUCKET_URL}/partner-grab.png`,
            `${S3_ASSETS_BUCKET_URL}/partner-lalamove.png`,
            `${S3_ASSETS_BUCKET_URL}/partner-ninjavan.png`,
            `${S3_ASSETS_BUCKET_URL}/partner-paymaya.png`,
            `${S3_ASSETS_BUCKET_URL}/partner-gcash.png`,
            `${S3_ASSETS_BUCKET_URL}/partner-bpi.png`,
            `${S3_ASSETS_BUCKET_URL}/partner-paymongo.png`,
        ];
    }
    goToLink(link) {
        window.open(link);
    }
    mounted() {
        const { ref } = this.$route.query;
        const params = {};
        if (ref) {
            // TODO: Update for Viber & Instagram
            const salesChannel = { salesChannel: ref === 'gcash' ? 'GLife' : 'FB Messenger' };
            Object.assign(params, salesChannel);
        }
        this.segmentTrack('Chatgenie Website Visit', params);
        if (!CG_BASE_URL.includes(this.getOrigin)) {
            this.$router.push('/login/client');
        }
    }
    get getOrigin() {
        const { origin } = window.location;
        return origin.replace(/^https?:\/\//i, '');
    }
};
Home = __decorate([
    Component({
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                if (vm.$store.state.session.authenticated) {
                    next('/apps');
                }
                vm.$store.state.displayHomeNav = true;
                return true;
            });
        },
        components: {
            HeroBanner,
            TheFooter,
            GetStarted,
            MerchantsList,
            BundleTypes,
            Hooper,
            Slide,
            HooperPagination,
            Awards,
        },
    })
], Home);
export default Home;
